import { object, string, date, array, InferType } from 'yup';
import { nameValidation } from '@percihealth/core-js';
import { CareDocumentDataSchema } from '../CareDocumentDataSchema';
import { CareDocumentClinicalAndExperienceOutcomesSchema } from '../CareDocumentClinicalAndExperienceOutcomesSchema';
import { InterimSummaryExpertSummarySchema } from './InterimSummaryExpertSummarySchema';
import { IObject } from '../../../IObject';
import { InterimCareSummarySupportProgressSchema } from './InterimCareSummarySupportProgressSchema';
import { CareDocumentWorkDetailsSchema } from '../CareDocumentWorkDetailsSchema';

export const InterimCareSummaryDataSchema = CareDocumentDataSchema.shape({
  patient: object().shape({
    fullName: nameValidation.required('Patient name is required'),
    dob: date().required('Patient date of birth is required'),
    cancerType: string().required('Cancer type is required'),
    // dateOfDiagnosis: date().required('Date of diagnosis is required'),
    work: CareDocumentWorkDetailsSchema,
    level: string(),
  }),
  perciStartDate: date().required('Perci Health start date is required'),
  dateOfInterimSummary: date().required(
    'Date of interim summary date is required',
  ),

  clinicalAndExperienceOutcomes:
    CareDocumentClinicalAndExperienceOutcomesSchema.required(),

  supportProgress: array()
    .of(InterimCareSummarySupportProgressSchema)
    .required(),

  gip: object().shape({
    code: string().required('GIP code is required'),
  }),
  expertFullName: string(),
  expertSummary: InterimSummaryExpertSummarySchema.required(),
});

export type InterimCareSummaryData = InferType<
  typeof InterimCareSummaryDataSchema
>;
export type InterimCareSummary =
  IObject.HasIdTimestamped<InterimCareSummaryData>;
